// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controldevice-page {
  min-height: 100dvh;
}

.controldevice-page,
.controldevice-page * {
  box-sizing: border-box;
}

.controldevice-title-line {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.controldevice-title-line .controlDeviceTitle {
  margin-bottom: 1.5rem !important;
}

.controldevice-page .controldevice-mobile-menu-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  margin-right: 8px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #006699;
  font-size: 25px;
  cursor: pointer;
}

.controldevice-page .controldevice-mobile-menu-toggle:hover,
.controldevice-page .controldevice-mobile-menu-toggle:focus-visible {
  background: #eaf4fb;
  outline: none;
}

.controldevice-service-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 13px;
  border-radius: 999px;
  background: #e7f8e8;
  color: #15823a;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.controldevice-service-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2ebd45;
  animation: controldevice-status-pulse 1.6s ease-in-out infinite;
}

@keyframes controldevice-status-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(46, 189, 69, 0.34);
  }

  50% {
    opacity: 0.72;
    transform: scale(1.24);
    box-shadow: 0 0 0 5px rgba(46, 189, 69, 0.08);
  }
}

.controldevice-info-value .controldevice-service-status {
  padding: 6px 10px;
  font-size: 12px;
}

.controldevice-info-value .controldevice-service-status-dot {
  width: 8px;
  height: 8px;
}

.controldevice-section-heading {
  display: none;
}

.controldevice-map-card #map {
  width: 100%;
  height: 240px;
  border: 1px solid #c4c4c4;
  border-radius: 14px;
  overflow: hidden;
}

.controldevice-map-card {
  position: relative;
}

.controldevice-map-fullscreen-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid rgba(215, 225, 236, 0.95);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  color: #305274;
  box-shadow: 0 3px 10px rgba(28, 58, 86, 0.18);
  cursor: pointer;
  font-size: 21px;
}

.controldevice-map-fullscreen-button:hover,
.controldevice-map-fullscreen-button:focus-visible {
  background: #006699;
  color: #fff;
  outline: none;
}

.controldevice-map-card:fullscreen #map,
.controldevice-map-card:-webkit-full-screen #map {
  height: 100% !important;
  border: 0 !important;
  border-radius: 0;
}

.controldevice-page .FondoHeaderTabla2 th,
.controldevice-page .FondoHeaderTabla2 th * {
  color: #fff !important;
}

/* En escritorio el mapa acompaña exactamente el alto del panel de datos. */
@media (min-width: 768px) {
  .controldevice-overview-row {
    align-items: stretch;
  }

  .controldevice-overview-row > .controldevice-info-col,
  .controldevice-overview-row > .controldevice-map-col {
    display: flex;
  }

  .controldevice-information-card,
  .controldevice-map-card {
    width: 100%;
  }

  .controldevice-map-card {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .controldevice-map-card #map {
    flex: 1 1 auto;
    height: auto;
    min-height: 100%;
  }
}

.controldevice-mobile-table-wrap {
  display: none;
}

.controldevice-realtime-sheet-backdrop {
  display: none;
}

.controldevice-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 18px;
}

.controldevice-additional-info-toggle {
  display: none;
}

.controldevice-info-item {
  display: grid;
  grid-template-columns: minmax(112px, 0.9fr) minmax(0, 1.1fr);
  align-items: center;
  min-width: 0;
  min-height: 38px;
  border-bottom: 1px solid #e7edf4;
}

.controldevice-info-label {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: #173961;
  font-size: 12px;
  line-height: 1.25;
}

.controldevice-info-label i {
  flex: 0 0 auto;
  color: #0874c9;
  font-size: 17px;
}

.controldevice-info-label b,
.controldevice-info-value {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.controldevice-info-value {
  color: #526d8f;
  font-size: 12px;
  line-height: 1.3;
}

.controldevice-lock-value {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
}

.controldevice-lock-value img {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
}

.controldevice-battery-value {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}

.controldevice-battery-progress {
  display: inline-flex;
  width: 86px;
  height: 12px;
  overflow: hidden;
  border-radius: 999px;
  background: #edf1f5;
  box-shadow: inset 0 1px 2px rgba(31, 55, 80, 0.08);
}

.controldevice-battery-progress > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #69bd3b;
  transition: width 240ms ease;
}

@media (max-width: 1199px) {
  .controldevice-page #layout-navbar.custom-navbar-admin {
    background: transparent !important;
  }

  body.controldevice-responsive-page #root {
    margin-left: 0 !important;
    overflow-x: hidden;
  }

  body.controldevice-responsive-page .barra-responsive-offcanvas {
    width: 100vw !important;
    max-width: 100vw !important;
    z-index: 13000;
  }

  body.controldevice-responsive-page .offcanvas-backdrop {
    z-index: 12990;
  }

  .controldevice-page .controldevice-mobile-menu-toggle {
    display: inline-flex;
  }

  .controldevice-page #layout-navbar {
    min-height: 64px;
    padding: 4px 12px 4px 8px;
  }

  .controldevice-page #layout-navbar .app-brand-link {
    min-width: 0;
    flex: 1 1 auto;
  }

  .controldevice-page #layout-navbar .app-brand-link img {
    width: min(190px, 100%);
    height: 56px !important;
    object-fit: contain;
    object-position: left center;
  }

  .controldevice-page #layout-navbar .navbar-nav-right {
    position: static;
    transform: none;
    flex: 0 0 auto;
  }

  .controldevice-page #layout-navbar .navbar-actions {
    gap: 4px;
  }

  .controldevice-page .content-wrapper {
    min-width: 0;
  }

  .controldevice-page .container-fluid.container-p-y {
    min-width: 0;
  }
}

@media (max-width: 767px) {
  body.controldevice-sheet-open {
    overflow: hidden;
  }

  .controldevice-page {
    min-height: 100dvh;
    overflow-x: hidden;
    background: #f5f7fb;
  }

  .controldevice-page #layout-navbar {
    min-height: 60px;
    padding: 4px 8px;
  }

  .controldevice-page #layout-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
  }

  .controldevice-page .content-wrapper {
    padding: 0 12px calc(78px + env(safe-area-inset-bottom));
  }

  .controldevice-page .container-fluid.container-p-y {
    padding: 16px 0 18px !important;
  }

  .controldevice-page .controldevice-header-row,
  .controldevice-page .controldevice-overview-row {
    display: block;
    margin-right: 0;
    margin-left: 0;
  }

  .controldevice-page .controldevice-header-row > [class*="col-"],
  .controldevice-page .controldevice-overview-row > [class*="col-"] {
    width: 100%;
    max-width: 100%;
    padding-right: 0;
    padding-left: 0;
  }

  .controldevice-title-line {
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 16px;
  }

  .controldevice-title-line .controlDeviceTitle {
    margin: 0 !important;
    color: #1c3558;
    font-size: 27px;
    line-height: 1.15;
    letter-spacing: -0.03em;
  }

  .controldevice-service-status {
    flex: 0 0 auto;
    padding: 7px 10px;
    font-size: 13px;
  }

  .controldevice-service-status-dot {
    width: 9px;
    height: 9px;
  }

  .controldevice-info-value .controldevice-service-status {
    max-width: 100%;
    padding: 6px 8px;
    font-size: 10px;
  }

  .controldevice-toolbar-col > .d-flex {
    height: auto !important;
    gap: 8px !important;
    margin-bottom: 14px;
  }

  .controldevice-toolbar-col .input-group {
    min-width: 0;
    height: 48px !important;
    min-height: 48px !important;
    max-height: 48px !important;
    border: 1px solid #d9e4ef;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06);
    overflow: hidden;
  }

  .controldevice-toolbar-col .input-group-text,
  .controldevice-toolbar-col .form-control {
    height: 46px !important;
    min-height: 46px !important;
    max-height: 46px !important;
    border: 0;
    background: #fff;
  }

  .controldevice-toolbar-col .input-group-text {
    padding: 0 10px !important;
    color: #4d6c8f;
  }

  .controldevice-toolbar-col .form-control {
    min-width: 0;
    padding: 0 8px !important;
    color: #234365;
    font-size: 15px;
  }

  .controldevice-toolbar-col .form-control::placeholder {
    color: #a1b2c4;
  }

  .controldevice-toolbar-col button {
    flex-basis: 44px !important;
    width: 44px !important;
    height: 44px !important;
    min-height: 44px !important;
    max-height: 44px !important;
    border-radius: 12px !important;
  }

  .controldevice-toolbar-col button.btn-outline-secondary {
    border-color: #8fa5bb;
    background: #fff;
    color: #4d6c8f;
  }

  .controldevice-toolbar-col button.btn:not(.btn-outline-secondary) {
    flex-basis: 48px !important;
    width: 48px !important;
    height: 48px !important;
    border-radius: 50% !important;
  }

  .controldevice-overview-row {
    display: flex !important;
    flex-direction: column;
    gap: 14px;
  }

  .controldevice-information-card,
  .controldevice-map-card,
  .controldevice-realtime-card {
    border: 1px solid #e0e8f1;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(37, 61, 86, 0.08);
  }

  .controldevice-information-card {
    padding: 14px 10px 12px;
    position: relative;
  }

  .controldevice-section-heading {
    display: flex;
    align-items: center;
    gap: 9px;
    min-width: 0;
    color: #123764;
    font-size: 17px;
    font-weight: 800;
    line-height: 1.2;
  }

  .controldevice-section-heading > i:first-child {
    flex: 0 0 auto;
    color: #0874c9;
    font-size: 23px;
  }

  .controldevice-section-heading > span {
    min-width: 0;
  }

  .controldevice-more-button,
  .controldevice-map-expand {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    margin-left: auto;
    padding: 0;
    border: 0;
    background: transparent;
    color: #507192;
    font: inherit;
    cursor: pointer;
  }

  .controldevice-more-button {
    width: 30px;
    height: 30px;
    font-size: 17px;
    letter-spacing: 2px;
  }

  .controldevice-actions-popover {
    position: absolute;
    top: 50px;
    right: 10px;
    z-index: 8;
    display: grid;
    min-width: 194px;
    padding: 6px;
    border: 1px solid #d7e4ef;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 10px 24px rgba(25, 55, 83, 0.18);
  }

  .controldevice-actions-popover button {
    display: flex;
    align-items: center;
    gap: 9px;
    width: 100%;
    min-height: 38px;
    padding: 8px 10px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #24486e;
    font-size: 12px;
    font-weight: 700;
    text-align: left;
  }

  .controldevice-actions-popover button:hover,
  .controldevice-actions-popover button:focus-visible {
    background: #edf6fc;
    color: #0874c9;
    outline: none;
  }

  .controldevice-actions-popover i,
  .controldevice-actions-popover svg {
    flex: 0 0 auto;
    color: #0874c9;
    font-size: 17px;
  }

  .controldevice-info-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0 12px;
    margin-top: 10px;
  }

  .controldevice-info-grid:not(.is-expanded) .controldevice-info-item--additional {
    display: none;
  }

  .controldevice-additional-info-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    min-height: 40px;
    margin-top: 10px;
    padding: 8px 12px;
    border: 1px solid #cfe0ef;
    border-radius: 10px;
    background: #f5faff;
    color: #0874c9;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.2;
    cursor: pointer;
  }

  .controldevice-additional-info-toggle:hover,
  .controldevice-additional-info-toggle:focus-visible {
    border-color: #87b9df;
    background: #eaf5fd;
    outline: none;
  }

  .controldevice-additional-info-toggle i {
    font-size: 18px;
    line-height: 1;
  }

  .controldevice-info-item {
    min-width: 0;
    padding: 10px 4px 9px;
    border-top: 1px solid #e7edf4;
  }

  .controldevice-info-label {
    display: flex;
    align-items: center;
    gap: 5px;
    min-width: 0;
    color: #173961;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.25;
  }

  .controldevice-info-label i {
    flex: 0 0 auto;
    color: #0874c9;
    font-size: 16px;
  }

  .controldevice-info-label b {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .controldevice-info-value {
    min-width: 0;
    margin-top: 4px;
    padding-left: 21px;
    color: #526d8f;
    font-size: 11px;
    line-height: 1.3;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .controldevice-battery-value {
    gap: 6px;
    flex-wrap: wrap;
  }

  .controldevice-battery-progress {
    width: min(76px, 100%);
    height: 10px;
  }

  .controldevice-info-value .controldevice-service-status {
    display: inline-flex;
    max-width: 100%;
    white-space: nowrap;
  }

  .controldevice-lock-value {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    max-width: 100%;
  }

  .controldevice-lock-value img {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
  }

  /* En teléfonos estrechos dos tarjetas por fila dejan los valores sin espacio.
     Cada dato conserva su icono, pero pasa a una fila propia y legible. */
  @media (max-width: 479px) {
    .controldevice-information-card {
      padding: 15px 14px 8px;
    }

    .controldevice-section-heading {
      padding-bottom: 11px;
      border-bottom: 1px solid #e4edf5;
    }

    .controldevice-info-grid {
      grid-template-columns: minmax(0, 1fr);
      gap: 0;
      margin-top: 0;
    }

    .controldevice-info-item {
      grid-template-columns: minmax(122px, 0.9fr) minmax(0, 1.1fr);
      column-gap: 10px;
      align-items: center;
      min-height: 40px;
      padding: 6px 0;
      border-top: 0;
      border-bottom: 1px solid #e7edf4;
    }

    .controldevice-info-item:last-child {
      border-bottom: 0;
    }

    .controldevice-info-label {
      gap: 7px;
      font-size: 11px;
      line-height: 1.2;
    }

    .controldevice-info-label i {
      width: 18px;
      font-size: 17px;
      text-align: center;
    }

    .controldevice-info-value {
      margin-top: 0;
      padding-left: 0;
      color: #415f82;
      font-size: 12px;
      line-height: 1.35;
      text-align: right;
    }

    .controldevice-battery-value {
      justify-content: flex-end;
    }

    .controldevice-info-value .controldevice-service-status {
      margin-left: auto;
      font-size: 11px;
    }

    .controldevice-lock-value {
      justify-content: flex-end;
    }
  }

  .controldevice-action-row {
    margin-top: 10px !important;
  }

  .controldevice-action-row > [class*="col-"] {
    width: 100%;
    max-width: 100%;
    padding: 0 4px;
  }

  .controldevice-action-row button {
    width: 100%;
    min-height: 40px;
    font-size: 12px;
  }

  .controldevice-inline-actions {
    display: none !important;
  }

  .controldevice-map-card {
    overflow: hidden;
  }

  .controldevice-map-card .controldevice-section-heading {
    min-height: 54px;
    padding: 9px 12px 7px;
  }

  .controldevice-map-expand {
    width: 34px;
    height: 34px;
    border: 1px solid #d9e4ef;
    border-radius: 9px;
    font-size: 22px;
  }

  .controldevice-map-card #map {
    width: 100%;
    height: 196px !important;
    border: 0 !important;
  }

  .controldevice-realtime-card {
    margin-top: 14px !important;
    /* 62 px del navbar fijo, más un respiro visual y el área segura. */
    margin-bottom: calc(84px + env(safe-area-inset-bottom));
    overflow: hidden;
  }

  .controldevice-realtime-heading {
    min-height: 52px;
    padding: 9px 12px 7px;
  }

  .controldevice-realtime-open {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-left: auto;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: #507192;
    cursor: pointer;
  }

  .controldevice-realtime-open i {
    font-size: 24px;
  }

  .controldevice-realtime-open:focus-visible {
    outline: 2px solid #0874c9;
    outline-offset: 2px;
  }

  .controldevice-realtime-sheet-backdrop {
    position: fixed;
    inset: 0;
    z-index: 14000;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: rgba(12, 30, 49, 0.42);
    animation: controldevice-sheet-fade-in 180ms ease-out both;
  }

  .controldevice-realtime-sheet {
    display: flex;
    width: 100%;
    height: min(56dvh, 520px);
    max-height: min(84dvh, 760px);
    flex-direction: column;
    overflow: hidden;
    border-radius: 24px 24px 0 0;
    background: #fff;
    box-shadow: 0 -12px 35px rgba(15, 39, 60, 0.24);
    animation: controldevice-sheet-slide-up 260ms cubic-bezier(0.22, 1, 0.36, 1) both;
    transition: height 220ms ease, max-height 220ms ease, border-radius 220ms ease, transform 180ms ease-out;
  }

  .controldevice-realtime-sheet.is-expanded {
    height: 100dvh;
    max-height: 100dvh;
    border-radius: 0;
  }

  .controldevice-realtime-sheet.is-dragging {
    transition: none;
    -webkit-user-select: none;
            user-select: none;
  }

  .controldevice-realtime-sheet-handle {
    display: flex;
    flex: 0 0 25px;
    align-items: center;
    justify-content: center;
    cursor: grab;
    touch-action: none;
  }

  .controldevice-realtime-sheet-handle:active {
    cursor: grabbing;
  }

  .controldevice-realtime-sheet-handle span {
    width: 42px;
    height: 5px;
    border-radius: 999px;
    background: #c4d0dc;
  }

  .controldevice-realtime-sheet-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 16px 13px;
    border-bottom: 1px solid #e4ebf2;
  }

  .controldevice-realtime-sheet-header > div {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 4px;
  }

  .controldevice-realtime-sheet-header strong {
    color: #123764;
    font-size: 17px;
  }

  .controldevice-realtime-sheet-header span {
    color: #71859a;
    font-size: 11px;
  }

  .controldevice-realtime-sheet-header button {
    display: none;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: #eef4f8;
    color: #42627f;
    font-size: 24px;
    line-height: 1;
  }

  .controldevice-realtime-sheet.is-expanded .controldevice-realtime-sheet-header button {
    display: inline-flex;
  }

  .controldevice-realtime-sheet-body {
    min-height: 0;
    overflow: auto;
    padding: 0 0 calc(14px + env(safe-area-inset-bottom));
    -webkit-overflow-scrolling: touch;
  }

  .controldevice-realtime-sheet-table-wrap {
    display: none;
  }

  .controldevice-realtime-sheet-records {
    display: grid;
    gap: 12px;
    padding: 12px 14px calc(16px + env(safe-area-inset-bottom));
  }

  .controldevice-realtime-sheet-empty {
    display: grid;
    min-height: 150px;
    place-items: center;
    align-content: center;
    gap: 8px;
    color: #60798f;
    font-size: 12px;
    text-align: center;
  }

  .controldevice-realtime-sheet-empty p {
    margin: 0;
  }

  .controldevice-realtime-record-card {
    overflow: hidden;
    border: 1px solid #dce7f0;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(36, 65, 92, 0.06);
  }

  .controldevice-realtime-record-card.is-interactive {
    cursor: pointer;
  }

  .controldevice-realtime-record-card:focus-visible {
    outline: 2px solid #0874c9;
    outline-offset: 2px;
  }

  .controldevice-realtime-record-card > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 12px;
    border-bottom: 1px solid #e4edf4;
    background: #f5faff;
  }

  .controldevice-realtime-record-card > header > div {
    display: grid;
    gap: 2px;
    min-width: 0;
  }

  .controldevice-realtime-record-card > header strong {
    color: #123764;
    font-size: 13px;
  }

  .controldevice-realtime-record-card > header span {
    overflow: hidden;
    color: #6d8399;
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .controldevice-realtime-record-card > header > i {
    flex: 0 0 auto;
    color: #0874c9;
    font-size: 21px;
  }

  .controldevice-realtime-record-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .controldevice-realtime-record-field {
    display: grid;
    gap: 3px;
    min-width: 0;
    padding: 9px 10px;
    border-bottom: 1px solid #edf2f6;
  }

  .controldevice-realtime-record-field:nth-child(odd) {
    border-right: 1px solid #edf2f6;
  }

  .controldevice-realtime-record-field span {
    color: #71869a;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .controldevice-realtime-record-field strong {
    overflow-wrap: anywhere;
    color: #24486e;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.3;
  }

  .controldevice-realtime-sheet-table {
    width: max-content;
    min-width: 1040px;
    margin: 0;
    font-size: 11px;
  }

  .controldevice-realtime-sheet-table th,
  .controldevice-realtime-sheet-table td {
    padding: 10px 8px;
    white-space: nowrap;
    vertical-align: middle;
  }

  .controldevice-realtime-sheet-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #0874c9 !important;
    color: #fff !important;
    font-size: 9px;
  }

  .controldevice-realtime-sheet-table thead th * {
    color: #fff !important;
  }

  @keyframes controldevice-sheet-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes controldevice-sheet-slide-up {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
  }

  .controldevice-desktop-table {
    display: none !important;
  }

  .controldevice-mobile-table-wrap {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .controldevice-mobile-table {
    width: max-content;
    min-width: 1480px;
    margin: 0;
    table-layout: auto;
    border-collapse: collapse;
    font-size: 10px;
  }

  .controldevice-mobile-table th,
  .controldevice-mobile-table td {
    min-width: 82px;
    padding: 9px 8px;
    overflow-wrap: normal;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }

  .controldevice-mobile-table th {
    background: #0874c9 !important;
    color: #fff !important;
    font-size: 9px;
    line-height: 1.15;
  }

  .controldevice-mobile-table td {
    color: #55708e;
    line-height: 1.25;
  }

  .controldevice-table-status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    padding: 4px 7px;
    border-radius: 999px;
    background: #e7f8e8;
    color: #15823a;
    font-size: 10px;
    font-weight: 700;
  }
}

@media (max-width: 374px) {
  .controldevice-title-line .controlDeviceTitle {
    font-size: 24px;
  }

  .controldevice-service-status {
    padding-right: 8px;
    padding-left: 8px;
    font-size: 12px;
  }

  .controldevice-info-item {
    grid-template-columns: minmax(112px, 0.88fr) minmax(0, 1.12fr);
    column-gap: 7px;
  }

  .controldevice-info-label {
    font-size: 10px;
  }

  .controldevice-info-value {
    font-size: 11px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .controldevice-service-status-dot,
  .controldevice-realtime-sheet-backdrop,
  .controldevice-realtime-sheet {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/controlDeviceResponsive.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,+DAA+D;AACjE;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,6CAA6C;EAC/C;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAUA;;EAEE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,2EAA2E;AAC3E;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,+BAA+B;EACjC;;EAEA;;IAEE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;IAC7C,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;IAGE,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,8CAA8C;EAChD;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;IACnB,cAAc;IACd,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;0EACwE;EACxE;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,oBAAoB;MACpB,gCAAgC;IAClC;;IAEA;MACE,qCAAqC;MACrC,MAAM;MACN,aAAa;IACf;;IAEA;MACE,4DAA4D;MAC5D,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;MAChB,cAAc;MACd,aAAa;MACb,gCAAgC;IAClC;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,QAAQ;MACR,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,eAAe;MACf,cAAc;MACd,eAAe;MACf,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;;IAEA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,mEAAmE;IACnE,uDAAuD;IACvD,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,kCAAkC;IAClC,0DAA0D;EAC5D;;EAEA;IACE,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,sBAAsB;IACtB,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,+CAA+C;IAC/C,iFAAiF;IACjF,wGAAwG;EAC1G;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,qDAAqD;IACrD,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,2DAA2D;EAC7D;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gDAAgD;EAClD;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,8BAA8B;IAC9B,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;EACnB;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,KAAK,wBAAwB,EAAE;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,8DAA8D;IAC9D,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,eAAe;EACjB;AACF","sourcesContent":[".controldevice-page {\n  min-height: 100dvh;\n}\n\n.controldevice-page,\n.controldevice-page * {\n  box-sizing: border-box;\n}\n\n.controldevice-title-line {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.controldevice-title-line .controlDeviceTitle {\n  margin-bottom: 1.5rem !important;\n}\n\n.controldevice-page .controldevice-mobile-menu-toggle {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 44px;\n  width: 44px;\n  height: 44px;\n  margin-right: 8px;\n  padding: 0;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #006699;\n  font-size: 25px;\n  cursor: pointer;\n}\n\n.controldevice-page .controldevice-mobile-menu-toggle:hover,\n.controldevice-page .controldevice-mobile-menu-toggle:focus-visible {\n  background: #eaf4fb;\n  outline: none;\n}\n\n.controldevice-service-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 13px;\n  border-radius: 999px;\n  background: #e7f8e8;\n  color: #15823a;\n  font-size: 14px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.controldevice-service-status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #2ebd45;\n  animation: controldevice-status-pulse 1.6s ease-in-out infinite;\n}\n\n@keyframes controldevice-status-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(46, 189, 69, 0.34);\n  }\n\n  50% {\n    opacity: 0.72;\n    transform: scale(1.24);\n    box-shadow: 0 0 0 5px rgba(46, 189, 69, 0.08);\n  }\n}\n\n.controldevice-info-value .controldevice-service-status {\n  padding: 6px 10px;\n  font-size: 12px;\n}\n\n.controldevice-info-value .controldevice-service-status-dot {\n  width: 8px;\n  height: 8px;\n}\n\n.controldevice-section-heading {\n  display: none;\n}\n\n.controldevice-map-card #map {\n  width: 100%;\n  height: 240px;\n  border: 1px solid #c4c4c4;\n  border-radius: 14px;\n  overflow: hidden;\n}\n\n.controldevice-map-card {\n  position: relative;\n}\n\n.controldevice-map-fullscreen-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 4;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid rgba(215, 225, 236, 0.95);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.96);\n  color: #305274;\n  box-shadow: 0 3px 10px rgba(28, 58, 86, 0.18);\n  cursor: pointer;\n  font-size: 21px;\n}\n\n.controldevice-map-fullscreen-button:hover,\n.controldevice-map-fullscreen-button:focus-visible {\n  background: #006699;\n  color: #fff;\n  outline: none;\n}\n\n.controldevice-map-card:fullscreen,\n.controldevice-map-card:-webkit-full-screen {\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n  background: #fff;\n}\n\n.controldevice-map-card:fullscreen #map,\n.controldevice-map-card:-webkit-full-screen #map {\n  height: 100% !important;\n  border: 0 !important;\n  border-radius: 0;\n}\n\n.controldevice-page .FondoHeaderTabla2 th,\n.controldevice-page .FondoHeaderTabla2 th * {\n  color: #fff !important;\n}\n\n/* En escritorio el mapa acompaña exactamente el alto del panel de datos. */\n@media (min-width: 768px) {\n  .controldevice-overview-row {\n    align-items: stretch;\n  }\n\n  .controldevice-overview-row > .controldevice-info-col,\n  .controldevice-overview-row > .controldevice-map-col {\n    display: flex;\n  }\n\n  .controldevice-information-card,\n  .controldevice-map-card {\n    width: 100%;\n  }\n\n  .controldevice-map-card {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n\n  .controldevice-map-card #map {\n    flex: 1 1 auto;\n    height: auto;\n    min-height: 100%;\n  }\n}\n\n.controldevice-mobile-table-wrap {\n  display: none;\n}\n\n.controldevice-realtime-sheet-backdrop {\n  display: none;\n}\n\n.controldevice-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0 18px;\n}\n\n.controldevice-additional-info-toggle {\n  display: none;\n}\n\n.controldevice-info-item {\n  display: grid;\n  grid-template-columns: minmax(112px, 0.9fr) minmax(0, 1.1fr);\n  align-items: center;\n  min-width: 0;\n  min-height: 38px;\n  border-bottom: 1px solid #e7edf4;\n}\n\n.controldevice-info-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  color: #173961;\n  font-size: 12px;\n  line-height: 1.25;\n}\n\n.controldevice-info-label i {\n  flex: 0 0 auto;\n  color: #0874c9;\n  font-size: 17px;\n}\n\n.controldevice-info-label b,\n.controldevice-info-value {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.controldevice-info-value {\n  color: #526d8f;\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.controldevice-lock-value {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n}\n\n.controldevice-lock-value img {\n  flex: 0 0 auto;\n  width: 22px;\n  height: 22px;\n}\n\n.controldevice-battery-value {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.controldevice-battery-progress {\n  display: inline-flex;\n  width: 86px;\n  height: 12px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #edf1f5;\n  box-shadow: inset 0 1px 2px rgba(31, 55, 80, 0.08);\n}\n\n.controldevice-battery-progress > span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: #69bd3b;\n  transition: width 240ms ease;\n}\n\n@media (max-width: 1199px) {\n  .controldevice-page #layout-navbar.custom-navbar-admin {\n    background: transparent !important;\n  }\n\n  body.controldevice-responsive-page #root {\n    margin-left: 0 !important;\n    overflow-x: hidden;\n  }\n\n  body.controldevice-responsive-page .barra-responsive-offcanvas {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    z-index: 13000;\n  }\n\n  body.controldevice-responsive-page .offcanvas-backdrop {\n    z-index: 12990;\n  }\n\n  .controldevice-page .controldevice-mobile-menu-toggle {\n    display: inline-flex;\n  }\n\n  .controldevice-page #layout-navbar {\n    min-height: 64px;\n    padding: 4px 12px 4px 8px;\n  }\n\n  .controldevice-page #layout-navbar .app-brand-link {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .controldevice-page #layout-navbar .app-brand-link img {\n    width: min(190px, 100%);\n    height: 56px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .controldevice-page #layout-navbar .navbar-nav-right {\n    position: static;\n    transform: none;\n    flex: 0 0 auto;\n  }\n\n  .controldevice-page #layout-navbar .navbar-actions {\n    gap: 4px;\n  }\n\n  .controldevice-page .content-wrapper {\n    min-width: 0;\n  }\n\n  .controldevice-page .container-fluid.container-p-y {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 767px) {\n  body.controldevice-sheet-open {\n    overflow: hidden;\n  }\n\n  .controldevice-page {\n    min-height: 100dvh;\n    overflow-x: hidden;\n    background: #f5f7fb;\n  }\n\n  .controldevice-page #layout-navbar {\n    min-height: 60px;\n    padding: 4px 8px;\n  }\n\n  .controldevice-page #layout-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n  }\n\n  .controldevice-page .content-wrapper {\n    padding: 0 12px calc(78px + env(safe-area-inset-bottom));\n  }\n\n  .controldevice-page .container-fluid.container-p-y {\n    padding: 16px 0 18px !important;\n  }\n\n  .controldevice-page .controldevice-header-row,\n  .controldevice-page .controldevice-overview-row {\n    display: block;\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .controldevice-page .controldevice-header-row > [class*=\"col-\"],\n  .controldevice-page .controldevice-overview-row > [class*=\"col-\"] {\n    width: 100%;\n    max-width: 100%;\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .controldevice-title-line {\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n\n  .controldevice-title-line .controlDeviceTitle {\n    margin: 0 !important;\n    color: #1c3558;\n    font-size: 27px;\n    line-height: 1.15;\n    letter-spacing: -0.03em;\n  }\n\n  .controldevice-service-status {\n    flex: 0 0 auto;\n    padding: 7px 10px;\n    font-size: 13px;\n  }\n\n  .controldevice-service-status-dot {\n    width: 9px;\n    height: 9px;\n  }\n\n  .controldevice-info-value .controldevice-service-status {\n    max-width: 100%;\n    padding: 6px 8px;\n    font-size: 10px;\n  }\n\n  .controldevice-toolbar-col > .d-flex {\n    height: auto !important;\n    gap: 8px !important;\n    margin-bottom: 14px;\n  }\n\n  .controldevice-toolbar-col .input-group {\n    min-width: 0;\n    height: 48px !important;\n    min-height: 48px !important;\n    max-height: 48px !important;\n    border: 1px solid #d9e4ef;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 3px 10px rgba(37, 61, 86, 0.06);\n    overflow: hidden;\n  }\n\n  .controldevice-toolbar-col .input-group-text,\n  .controldevice-toolbar-col .form-control {\n    height: 46px !important;\n    min-height: 46px !important;\n    max-height: 46px !important;\n    border: 0;\n    background: #fff;\n  }\n\n  .controldevice-toolbar-col .input-group-text {\n    padding: 0 10px !important;\n    color: #4d6c8f;\n  }\n\n  .controldevice-toolbar-col .form-control {\n    min-width: 0;\n    padding: 0 8px !important;\n    color: #234365;\n    font-size: 15px;\n  }\n\n  .controldevice-toolbar-col .form-control::placeholder {\n    color: #a1b2c4;\n  }\n\n  .controldevice-toolbar-col button {\n    flex-basis: 44px !important;\n    width: 44px !important;\n    height: 44px !important;\n    min-height: 44px !important;\n    max-height: 44px !important;\n    border-radius: 12px !important;\n  }\n\n  .controldevice-toolbar-col button.btn-outline-secondary {\n    border-color: #8fa5bb;\n    background: #fff;\n    color: #4d6c8f;\n  }\n\n  .controldevice-toolbar-col button.btn:not(.btn-outline-secondary) {\n    flex-basis: 48px !important;\n    width: 48px !important;\n    height: 48px !important;\n    border-radius: 50% !important;\n  }\n\n  .controldevice-overview-row {\n    display: flex !important;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  .controldevice-information-card,\n  .controldevice-map-card,\n  .controldevice-realtime-card {\n    border: 1px solid #e0e8f1;\n    border-radius: 16px;\n    background: #fff;\n    box-shadow: 0 4px 16px rgba(37, 61, 86, 0.08);\n  }\n\n  .controldevice-information-card {\n    padding: 14px 10px 12px;\n    position: relative;\n  }\n\n  .controldevice-section-heading {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    min-width: 0;\n    color: #123764;\n    font-size: 17px;\n    font-weight: 800;\n    line-height: 1.2;\n  }\n\n  .controldevice-section-heading > i:first-child {\n    flex: 0 0 auto;\n    color: #0874c9;\n    font-size: 23px;\n  }\n\n  .controldevice-section-heading > span {\n    min-width: 0;\n  }\n\n  .controldevice-more-button,\n  .controldevice-map-expand {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    margin-left: auto;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: #507192;\n    font: inherit;\n    cursor: pointer;\n  }\n\n  .controldevice-more-button {\n    width: 30px;\n    height: 30px;\n    font-size: 17px;\n    letter-spacing: 2px;\n  }\n\n  .controldevice-actions-popover {\n    position: absolute;\n    top: 50px;\n    right: 10px;\n    z-index: 8;\n    display: grid;\n    min-width: 194px;\n    padding: 6px;\n    border: 1px solid #d7e4ef;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 10px 24px rgba(25, 55, 83, 0.18);\n  }\n\n  .controldevice-actions-popover button {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    width: 100%;\n    min-height: 38px;\n    padding: 8px 10px;\n    border: 0;\n    border-radius: 8px;\n    background: transparent;\n    color: #24486e;\n    font-size: 12px;\n    font-weight: 700;\n    text-align: left;\n  }\n\n  .controldevice-actions-popover button:hover,\n  .controldevice-actions-popover button:focus-visible {\n    background: #edf6fc;\n    color: #0874c9;\n    outline: none;\n  }\n\n  .controldevice-actions-popover i,\n  .controldevice-actions-popover svg {\n    flex: 0 0 auto;\n    color: #0874c9;\n    font-size: 17px;\n  }\n\n  .controldevice-info-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0 12px;\n    margin-top: 10px;\n  }\n\n  .controldevice-info-grid:not(.is-expanded) .controldevice-info-item--additional {\n    display: none;\n  }\n\n  .controldevice-additional-info-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    width: 100%;\n    min-height: 40px;\n    margin-top: 10px;\n    padding: 8px 12px;\n    border: 1px solid #cfe0ef;\n    border-radius: 10px;\n    background: #f5faff;\n    color: #0874c9;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1.2;\n    cursor: pointer;\n  }\n\n  .controldevice-additional-info-toggle:hover,\n  .controldevice-additional-info-toggle:focus-visible {\n    border-color: #87b9df;\n    background: #eaf5fd;\n    outline: none;\n  }\n\n  .controldevice-additional-info-toggle i {\n    font-size: 18px;\n    line-height: 1;\n  }\n\n  .controldevice-info-item {\n    min-width: 0;\n    padding: 10px 4px 9px;\n    border-top: 1px solid #e7edf4;\n  }\n\n  .controldevice-info-label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    min-width: 0;\n    color: #173961;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1.25;\n  }\n\n  .controldevice-info-label i {\n    flex: 0 0 auto;\n    color: #0874c9;\n    font-size: 16px;\n  }\n\n  .controldevice-info-label b {\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n\n  .controldevice-info-value {\n    min-width: 0;\n    margin-top: 4px;\n    padding-left: 21px;\n    color: #526d8f;\n    font-size: 11px;\n    line-height: 1.3;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n\n  .controldevice-battery-value {\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n\n  .controldevice-battery-progress {\n    width: min(76px, 100%);\n    height: 10px;\n  }\n\n  .controldevice-info-value .controldevice-service-status {\n    display: inline-flex;\n    max-width: 100%;\n    white-space: nowrap;\n  }\n\n  .controldevice-lock-value {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    max-width: 100%;\n  }\n\n  .controldevice-lock-value img {\n    flex: 0 0 auto;\n    width: 20px;\n    height: 20px;\n  }\n\n  /* En teléfonos estrechos dos tarjetas por fila dejan los valores sin espacio.\n     Cada dato conserva su icono, pero pasa a una fila propia y legible. */\n  @media (max-width: 479px) {\n    .controldevice-information-card {\n      padding: 15px 14px 8px;\n    }\n\n    .controldevice-section-heading {\n      padding-bottom: 11px;\n      border-bottom: 1px solid #e4edf5;\n    }\n\n    .controldevice-info-grid {\n      grid-template-columns: minmax(0, 1fr);\n      gap: 0;\n      margin-top: 0;\n    }\n\n    .controldevice-info-item {\n      grid-template-columns: minmax(122px, 0.9fr) minmax(0, 1.1fr);\n      column-gap: 10px;\n      align-items: center;\n      min-height: 40px;\n      padding: 6px 0;\n      border-top: 0;\n      border-bottom: 1px solid #e7edf4;\n    }\n\n    .controldevice-info-item:last-child {\n      border-bottom: 0;\n    }\n\n    .controldevice-info-label {\n      gap: 7px;\n      font-size: 11px;\n      line-height: 1.2;\n    }\n\n    .controldevice-info-label i {\n      width: 18px;\n      font-size: 17px;\n      text-align: center;\n    }\n\n    .controldevice-info-value {\n      margin-top: 0;\n      padding-left: 0;\n      color: #415f82;\n      font-size: 12px;\n      line-height: 1.35;\n      text-align: right;\n    }\n\n    .controldevice-battery-value {\n      justify-content: flex-end;\n    }\n\n    .controldevice-info-value .controldevice-service-status {\n      margin-left: auto;\n      font-size: 11px;\n    }\n\n    .controldevice-lock-value {\n      justify-content: flex-end;\n    }\n  }\n\n  .controldevice-action-row {\n    margin-top: 10px !important;\n  }\n\n  .controldevice-action-row > [class*=\"col-\"] {\n    width: 100%;\n    max-width: 100%;\n    padding: 0 4px;\n  }\n\n  .controldevice-action-row button {\n    width: 100%;\n    min-height: 40px;\n    font-size: 12px;\n  }\n\n  .controldevice-inline-actions {\n    display: none !important;\n  }\n\n  .controldevice-map-card {\n    overflow: hidden;\n  }\n\n  .controldevice-map-card .controldevice-section-heading {\n    min-height: 54px;\n    padding: 9px 12px 7px;\n  }\n\n  .controldevice-map-expand {\n    width: 34px;\n    height: 34px;\n    border: 1px solid #d9e4ef;\n    border-radius: 9px;\n    font-size: 22px;\n  }\n\n  .controldevice-map-card #map {\n    width: 100%;\n    height: 196px !important;\n    border: 0 !important;\n  }\n\n  .controldevice-realtime-card {\n    margin-top: 14px !important;\n    /* 62 px del navbar fijo, más un respiro visual y el área segura. */\n    margin-bottom: calc(84px + env(safe-area-inset-bottom));\n    overflow: hidden;\n  }\n\n  .controldevice-realtime-heading {\n    min-height: 52px;\n    padding: 9px 12px 7px;\n  }\n\n  .controldevice-realtime-open {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    margin-left: auto;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: transparent;\n    color: #507192;\n    cursor: pointer;\n  }\n\n  .controldevice-realtime-open i {\n    font-size: 24px;\n  }\n\n  .controldevice-realtime-open:focus-visible {\n    outline: 2px solid #0874c9;\n    outline-offset: 2px;\n  }\n\n  .controldevice-realtime-sheet-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 14000;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    background: rgba(12, 30, 49, 0.42);\n    animation: controldevice-sheet-fade-in 180ms ease-out both;\n  }\n\n  .controldevice-realtime-sheet {\n    display: flex;\n    width: 100%;\n    height: min(56dvh, 520px);\n    max-height: min(84dvh, 760px);\n    flex-direction: column;\n    overflow: hidden;\n    border-radius: 24px 24px 0 0;\n    background: #fff;\n    box-shadow: 0 -12px 35px rgba(15, 39, 60, 0.24);\n    animation: controldevice-sheet-slide-up 260ms cubic-bezier(0.22, 1, 0.36, 1) both;\n    transition: height 220ms ease, max-height 220ms ease, border-radius 220ms ease, transform 180ms ease-out;\n  }\n\n  .controldevice-realtime-sheet.is-expanded {\n    height: 100dvh;\n    max-height: 100dvh;\n    border-radius: 0;\n  }\n\n  .controldevice-realtime-sheet.is-dragging {\n    transition: none;\n    user-select: none;\n  }\n\n  .controldevice-realtime-sheet-handle {\n    display: flex;\n    flex: 0 0 25px;\n    align-items: center;\n    justify-content: center;\n    cursor: grab;\n    touch-action: none;\n  }\n\n  .controldevice-realtime-sheet-handle:active {\n    cursor: grabbing;\n  }\n\n  .controldevice-realtime-sheet-handle span {\n    width: 42px;\n    height: 5px;\n    border-radius: 999px;\n    background: #c4d0dc;\n  }\n\n  .controldevice-realtime-sheet-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 8px 16px 13px;\n    border-bottom: 1px solid #e4ebf2;\n  }\n\n  .controldevice-realtime-sheet-header > div {\n    display: flex;\n    min-width: 0;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .controldevice-realtime-sheet-header strong {\n    color: #123764;\n    font-size: 17px;\n  }\n\n  .controldevice-realtime-sheet-header span {\n    color: #71859a;\n    font-size: 11px;\n  }\n\n  .controldevice-realtime-sheet-header button {\n    display: none;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    width: 34px;\n    height: 34px;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: #eef4f8;\n    color: #42627f;\n    font-size: 24px;\n    line-height: 1;\n  }\n\n  .controldevice-realtime-sheet.is-expanded .controldevice-realtime-sheet-header button {\n    display: inline-flex;\n  }\n\n  .controldevice-realtime-sheet-body {\n    min-height: 0;\n    overflow: auto;\n    padding: 0 0 calc(14px + env(safe-area-inset-bottom));\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .controldevice-realtime-sheet-table-wrap {\n    display: none;\n  }\n\n  .controldevice-realtime-sheet-records {\n    display: grid;\n    gap: 12px;\n    padding: 12px 14px calc(16px + env(safe-area-inset-bottom));\n  }\n\n  .controldevice-realtime-sheet-empty {\n    display: grid;\n    min-height: 150px;\n    place-items: center;\n    align-content: center;\n    gap: 8px;\n    color: #60798f;\n    font-size: 12px;\n    text-align: center;\n  }\n\n  .controldevice-realtime-sheet-empty p {\n    margin: 0;\n  }\n\n  .controldevice-realtime-record-card {\n    overflow: hidden;\n    border: 1px solid #dce7f0;\n    border-radius: 14px;\n    background: #fff;\n    box-shadow: 0 3px 10px rgba(36, 65, 92, 0.06);\n  }\n\n  .controldevice-realtime-record-card.is-interactive {\n    cursor: pointer;\n  }\n\n  .controldevice-realtime-record-card:focus-visible {\n    outline: 2px solid #0874c9;\n    outline-offset: 2px;\n  }\n\n  .controldevice-realtime-record-card > header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 10px 12px;\n    border-bottom: 1px solid #e4edf4;\n    background: #f5faff;\n  }\n\n  .controldevice-realtime-record-card > header > div {\n    display: grid;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  .controldevice-realtime-record-card > header strong {\n    color: #123764;\n    font-size: 13px;\n  }\n\n  .controldevice-realtime-record-card > header span {\n    overflow: hidden;\n    color: #6d8399;\n    font-size: 10px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .controldevice-realtime-record-card > header > i {\n    flex: 0 0 auto;\n    color: #0874c9;\n    font-size: 21px;\n  }\n\n  .controldevice-realtime-record-fields {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .controldevice-realtime-record-field {\n    display: grid;\n    gap: 3px;\n    min-width: 0;\n    padding: 9px 10px;\n    border-bottom: 1px solid #edf2f6;\n  }\n\n  .controldevice-realtime-record-field:nth-child(odd) {\n    border-right: 1px solid #edf2f6;\n  }\n\n  .controldevice-realtime-record-field span {\n    color: #71869a;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n  }\n\n  .controldevice-realtime-record-field strong {\n    overflow-wrap: anywhere;\n    color: #24486e;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.3;\n  }\n\n  .controldevice-realtime-sheet-table {\n    width: max-content;\n    min-width: 1040px;\n    margin: 0;\n    font-size: 11px;\n  }\n\n  .controldevice-realtime-sheet-table th,\n  .controldevice-realtime-sheet-table td {\n    padding: 10px 8px;\n    white-space: nowrap;\n    vertical-align: middle;\n  }\n\n  .controldevice-realtime-sheet-table th {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background: #0874c9 !important;\n    color: #fff !important;\n    font-size: 9px;\n  }\n\n  .controldevice-realtime-sheet-table thead th * {\n    color: #fff !important;\n  }\n\n  @keyframes controldevice-sheet-fade-in {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n\n  @keyframes controldevice-sheet-slide-up {\n    from { transform: translateY(100%); }\n    to { transform: translateY(0); }\n  }\n\n  .controldevice-desktop-table {\n    display: none !important;\n  }\n\n  .controldevice-mobile-table-wrap {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .controldevice-mobile-table {\n    width: max-content;\n    min-width: 1480px;\n    margin: 0;\n    table-layout: auto;\n    border-collapse: collapse;\n    font-size: 10px;\n  }\n\n  .controldevice-mobile-table th,\n  .controldevice-mobile-table td {\n    min-width: 82px;\n    padding: 9px 8px;\n    overflow-wrap: normal;\n    text-align: center;\n    vertical-align: middle;\n    white-space: nowrap;\n  }\n\n  .controldevice-mobile-table th {\n    background: #0874c9 !important;\n    color: #fff !important;\n    font-size: 9px;\n    line-height: 1.15;\n  }\n\n  .controldevice-mobile-table td {\n    color: #55708e;\n    line-height: 1.25;\n  }\n\n  .controldevice-table-status {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 28px;\n    padding: 4px 7px;\n    border-radius: 999px;\n    background: #e7f8e8;\n    color: #15823a;\n    font-size: 10px;\n    font-weight: 700;\n  }\n}\n\n@media (max-width: 374px) {\n  .controldevice-title-line .controlDeviceTitle {\n    font-size: 24px;\n  }\n\n  .controldevice-service-status {\n    padding-right: 8px;\n    padding-left: 8px;\n    font-size: 12px;\n  }\n\n  .controldevice-info-item {\n    grid-template-columns: minmax(112px, 0.88fr) minmax(0, 1.12fr);\n    column-gap: 7px;\n  }\n\n  .controldevice-info-label {\n    font-size: 10px;\n  }\n\n  .controldevice-info-value {\n    font-size: 11px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .controldevice-service-status-dot,\n  .controldevice-realtime-sheet-backdrop,\n  .controldevice-realtime-sheet {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
